/* eslint-disable no-nested-ternary */
import {
  applyKrpanoPublicLogVisibility,
  isKrpanoPublicLogEnabled,
} from './constants';
import {
  IDENTITY_PREALIGN,
  formatKrpanoPrealign,
  sphereImageXml,
  withImagePrealign,
} from './krpanoPrealign';

export default function KRPANO(panoId) {
  function krpanoInstance() {
    return document.getElementById(panoId);
  }

  function init(targetElementId, xmlPath, defaultSettings) {
    let settings = {};
    if (defaultSettings) settings = defaultSettings;
    const isLogEnabled = isKrpanoPublicLogEnabled();
    settings.panoId = panoId;
    settings.showerrors = isLogEnabled;
    settings.logkey = isLogEnabled;
    settings.debugmode = isLogEnabled;
    settings.debugkeys = isLogEnabled;

    try {
      window.embedpano({
        target: targetElementId,
        // swf: '/core/tour.swf',
        html5: 'only+webgl',
        xml: xmlPath,
        bgcolor: '#000000',
        // mobilescale: 1.0,
        // passQueryParameters: true,
        id: panoId,
        vars: settings,
        initvars: defaultSettings,
        webglsettings: { preserveDrawingBuffer: true },
        consolelog: process.env.NODE_ENV === 'development' || isLogEnabled,
        onready: krpano => {
          applyKrpanoPublicLogVisibility(krpano);
        },
      });
      if (window.listKrpanoInstance) {
        const { listKrpanoInstance } = window;
        window.listKrpanoInstance = [...listKrpanoInstance, panoId];
      } else window.listKrpanoInstance = [panoId];
    } catch (e) {
      console.error(e);
    }

    on('onloadcomplete', () => {
      const myCustomEventOnLoadComplete = new Event('onloadcomplete');
      if (krpanoInstance())
        krpanoInstance().dispatchEvent(myCustomEventOnLoadComplete);
    });
    on('onblendstart', () => {
      const event = new Event('onblendstart');
      if (krpanoInstance()) krpanoInstance().dispatchEvent(event);
    });
    on('onblendcomplete', () => {
      const event = new Event('onblendcomplete');
      if (krpanoInstance()) krpanoInstance().dispatchEvent(event);
    });
    on('onloaderror', () => {
      const event = new Event('onloaderror');
      if (krpanoInstance()) krpanoInstance().dispatchEvent(event);
    });

    on('onviewchange', () => {
      const krpano = krpanoInstance();
      if (!krpano || krpano.get('image.type') === 'flat') return;
      krpano.dispatchEvent(new Event('onviewchange'));
    });
    on('ondoubleclick', () => {
      const myCustomEventOnClick = new Event('ondoubleclick');
      if (krpanoInstance())
        krpanoInstance().dispatchEvent(myCustomEventOnClick);
    });
    on('onmousewheel', () => {
      const myCustomEventOnMouseWheel = new Event('onmousewheel');
      if (krpanoInstance())
        krpanoInstance().dispatchEvent(myCustomEventOnMouseWheel);
    });
    on('onmouseup', () => {
      const myCustomEventOnMouseUp = new Event('onmouseup');
      if (krpanoInstance())
        krpanoInstance().dispatchEvent(myCustomEventOnMouseUp);
    });
    on('onmousedown', () => {
      const myCustomEventOnMouseDown = new Event('onmousedown');
      if (krpanoInstance())
        krpanoInstance().dispatchEvent(myCustomEventOnMouseDown);
    });
    on('onnewpanovr', () => {
      const myCustomEventOnNewPanoVR = new Event('onnewpanovr');
      if (krpanoInstance())
        krpanoInstance().dispatchEvent(myCustomEventOnNewPanoVR);
    });
    window[panoId] = krpanoInstance();
  }

  function removePano() {
    if (window.listKrpanoInstance)
      window.listKrpanoInstance = window.listKrpanoInstance.filter(
        item => item !== panoId,
      );

    window.removepano(panoId);
  }

  function loadScene(
    urlImage,
    vars,
    xml,
    transition = 'NOBLEND',
    view = '<view />',
    mode = '',
    sceneChilds = [],
    config = {},
    fovDefault = 90,
    sceneType,
    dollhouseXml = '',
    isShowDollhouseOnStart = false,
  ) {
    const skipPrealign = sceneType === 'flat';
    const prealign = skipPrealign
      ? IDENTITY_PREALIGN
      : (vars && vars['image.prealign']) || IDENTITY_PREALIGN;
    const alignedXml =
      xml && !skipPrealign ? withImagePrealign(xml, prealign) : xml;

    let varsString = '';
    if (vars) {
      Object.entries(vars).forEach(([key, value]) => {
        if (key === 'image.prealign') return;
        varsString += `${key}=${value}&`;
      });
    }

    let krpanoXml = `<krpano syncother="false">`;

    const day2duskBlendTime = config.waitTime ?? 0.35;
    const day2duskDurationTime = config.durationTime ?? 3;
    const day2duskFlags = 'MERGE|KEEPVIEW|KEEPMOVING|PRELOAD|IMAGEONLY';

    krpanoXml += `
      <action name="startup">
        set(view.oz, 0.0);
        clearinterval(day2dust);
        set(day2dusk_request, false);
        set(day2dusk_blending, false);
        ifnot(panoee_transition_busy, set(panoee_transition_busy, false));
    `;
    if (isShowDollhouseOnStart)
      krpanoXml += `dollhouse_view(true);</action>${dollhouseXml}`;
    else {
      if (mode === 'day2dust' && sceneChilds.length) {
        krpanoXml += `
          ifnot(day2dusk_token, set(day2dusk_token, 0); );
          setinterval(day2dust, ${day2duskDurationTime},
            if(panoee_transition_busy == false,
              if(day2dusk_request == false,
                if(day2dusk_blending == false,
                  set(day2dusk_request, true);
                  inc(day2dusk_token);
                  js(window.__panoeeKrpanoTransition &amp;&amp; window.__panoeeKrpanoTransition.onDayDuskRequest());
                  if(sceneActive === "scene_01",
                    loadscene(scene_00, null, ${day2duskFlags}, BLEND(${day2duskBlendTime}, easeInCubic), daydusk_load_done());
                    ,
                    loadscene(scene_01, null, ${day2duskFlags}, BLEND(${day2duskBlendTime}, easeInCubic), daydusk_load_done());
                  );
                );
              );
            );
          );`;
      }
      krpanoXml += '</action>';
      if (mode === 'day2dust' && sceneChilds.length) {
        krpanoXml += `<action name="daydusk_load_done">
          js(window.__panoeeKrpanoTransition &amp;&amp; window.__panoeeKrpanoTransition.onDayDuskLoadDone());
        </action>`;
      }

      krpanoXml += '<include url="%$mypath%/core/sync.xml" />';

      if (sceneType === 'flat')
        krpanoXml +=
          '<include url="%$mypath%/core/plugins/flat-scene.xml?v=2026.10.07.04" />';
      else krpanoXml += `<control mode="drag" />`; // Set default là drag
      if (alignedXml) {
        krpanoXml += `${alignedXml}${view}`;
        krpanoXml += `
        <scene name="scene_00" onstart="set(sceneActive, scene_00); set(sceneid, null);" nogrid="true">
          ${alignedXml}${view}
        </scene>
      `;
      } else {
        krpanoXml +=
          sceneType === 'flat'
            ? `<preview url="${urlImage}" /><image hfov="1.00" voffset="0.00"><flat url="${urlImage}"/></image>
      <scene name="scene_00" onstart="set(sceneActive, scene_00); set(sceneid, null);" nogrid="true">
      <preview url="${urlImage}" /><image hfov="1.00" voffset="0.00"><flat url="${urlImage}"/></image>
      </scene>`
            : `${sphereImageXml(urlImage, prealign, view)}
      <scene name="scene_00" onstart="set(sceneActive, scene_00); set(sceneid, null);" nogrid="true">
      ${sphereImageXml(urlImage, prealign, view)}
      </scene>`;
      }

      if (mode === 'day2dust' && sceneChilds.length) {
        sceneChilds.forEach((sceneChild, index) => {
          const childPrealign = skipPrealign
            ? IDENTITY_PREALIGN
            : formatKrpanoPrealign(sceneChild.orientation);
          const childXml = sceneChild.xml
            ? `${withImagePrealign(sceneChild.xml, childPrealign)}${view}`
            : sphereImageXml(sceneChild.urlTour, childPrealign, view);
          krpanoXml += `<scene name="scene_0${
            index + 1
          }" onstart="set(sceneActive, scene_0${
            index + 1
          }); set(sceneid, null);" nogrid="true">
              ${childXml}
            </scene>`;
        });
      }

      if (
        mode === 'staging' &&
        sceneChilds.length &&
        config.modeDisplay === ''
      ) {
        sceneChilds.forEach((sceneChild, index) => {
          const childPrealign = skipPrealign
            ? IDENTITY_PREALIGN
            : formatKrpanoPrealign(sceneChild.orientation);
          const childXml = sceneChild.xml
            ? `${withImagePrealign(sceneChild.xml, childPrealign)}${view}`
            : sphereImageXml(sceneChild.urlTour, childPrealign, view);
          krpanoXml += `<scene name="scene_0${
            index + 1
          }" nogrid="true" onstart="set(sceneid, null);">
              ${childXml}
            </scene>`;
        });
      }

      krpanoXml += `<hotspot name="hotspot_media_overlay" zorder="1" distorted="true" ath="0" atv="0" enabled="false" type="text" renderer="webgl" bgcolor="0x000000" bgalpha="1.0" width="100%" height="100%" alpha="0.85" scale="1" flying="1" visible="false" />`;
      krpanoXml += dollhouseXml;
    }
    krpanoXml += '</krpano>';

    krpanoInstance().call(
      `
        ${
          transition === 'OPENBLEND(0.5, 0.0, 0.75, 0.05, linear)' &&
          sceneType !== 'flat'
            ? 'wait(1.1)'
            : ''
        };
        loadxml(${krpanoXml}, ${varsString || null}, KEEPPLUGINS,
          ${sceneType === 'flat' ? null : transition}, startup);
        ${
          sceneType !== 'flat' && !isShowDollhouseOnStart
            ? `set("view.fov", ${fovDefault})`
            : ``
        }
        ${
          transition === 'OPENBLEND(0.5, 0.0, 0.75, 0.05, linear)' &&
          sceneType !== 'flat' &&
          !isShowDollhouseOnStart
            ? `wait(0.25);
            trace(view.fov);
            tween(view.fov, ${fovDefault}, 2);`
            : ''
        };
      `,
    );
  }

  function on(eventName, callback, eventId) {
    if (typeof callback === 'function' && krpanoInstance() !== null) {
      if (eventId) {
        try {
          krpanoInstance().set(`events['${eventId}'].${eventName}`, callback);
        } catch (e) {
          console.error(e);
        }
      } else {
        try {
          krpanoInstance().set(`events.${eventName}`, callback);
        } catch (e) {
          console.error(e);
        }
      }
    }
  }

  return {
    init,
    krpano: krpanoInstance(),
    loadScene,
    removePano,
  };
}
